import {Button, Modal, ModalBody, ModalFooter, Input, FormGroup, Label, FormText} from "reactstrap";
import React, {useState, useEffect} from "react";
import {TextInputHook} from "hooks/text_input.hook";
import * as Commands from '../redux/studi.commands'
import {CSSTransition} from "react-transition-group";
import {useSelector} from 'react-redux'
import Select from "react-select";

export default function UpdateProductionComponent(props) {

    const nome = TextInputHook(props.name);
    const [submitError, setSubmitError] = useState(false);
    const [loading, setLoading] = useState(false);

    const [contract, setContract] = useState(props.contract);
    const contracts = useSelector(state => state.contract.data);

    const addressList = useSelector(state => state.raiIndirizzi.data);
    const [address, setAddress] = useState(addressList.filter((address)=>(address.id === props.address.id))[0]);

    //const [sectorsSelected, setSectorsSelected] = useState(sectors.filter((sector)=>(props.sectors.includes(sector.id))));

    const Submit = async () => {
        setLoading(true);

        var res = await Commands.AggiornaStudio(props.id, nome.getValue(), address, contract.id);
        setLoading(false);

        if (res.hasError) {
            setSubmitError(true);
            return;
        }

        clearForm();
        props.toggle();
    };


    const clearForm = () => {
        nome.clear();
        setAddress(undefined);
        setContract(undefined);
    }


    useEffect(() => {

        if (submitError) {

            const timer = setTimeout(() => {
                setSubmitError(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [submitError]);

    return (
        <Modal
            modalClassName="modal-black"
            isOpen={props.show}
            toggle={props.toggle}
        >
            <div className="modal-header justify-content-center">
                <button
                    aria-hidden={true}
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={props.toggle}
                >
                    <i className="tim-icons icon-simple-remove"/>
                </button>
                <h6 className="title title-up">Modifica studio</h6>
            </div>
            <ModalBody>
                <form onSubmit={e => {
                    e.preventDefault();
                    Submit();
                }}>
                    <FormGroup>
                        <Label for="nome">Nome</Label>
                        <Input
                            {...nome.input}
                            name="nome"
                            id="nome"
                            placeholder="Inserisci nome studio"
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label for="luogo">Luogo</Label>
                        <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            value={address}
                            getOptionLabel={(item) => item.description}
                            onChange={value =>
                                setAddress(value)
                            }
                            options={[{
                                value: "",
                                description: "Luogo",
                                isDisabled: true
                            }, ...addressList]}
                            placeholder="Seleziona un luogo"
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label for="contratto">Contratto</Label>
                        <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            value={contract}
                            getOptionLabel={(item) => item.description}
                            onChange={value => {
                                setContract(value);
                            }}
                            options={[{
                                value: "",
                                description: "Contratto",
                                isDisabled: true
                            }, ...contracts]}
                            placeholder="Seleziona un contratto"
                        />
                        <FormText color="muted">
                            Contratto a cui si riferisce lo studio
                        </FormText>
                    </FormGroup>
                    {/*Il button serve solo per permettere il submit del form con il pulsante enter */}
                    <button style={{display: 'none'}} type="submit"/>
                </form>
                <CSSTransition
                    in={submitError}
                    appear={true}
                    unmountOnExit
                    classNames="error"
                    timeout={300}
                >
                    <blockquote className="blockquote blockquote-danger">
                        <p className="mb-0 text-danger">Non è stato possibile salvare lo studio.</p>
                    </blockquote>
                </CSSTransition>

            </ModalBody>
            <ModalFooter>
                <Button
                    color="danger"
                    data-dismiss="modal"
                    type="button"
                    onClick={props.toggle}
                >
                    Annulla
                </Button>
                <Button
                    color="primary"
                    type="button"
                    onClick={Submit}
                >
                    {loading ?
                        <i className="fa fa-spin fa-spinner"/>
                        : 'Salva'}
                </Button>
            </ModalFooter>
        </Modal>
    );

}
